import React, { useEffect, useState } from 'react';
import { matchPath, useLocation } from 'react-router-dom';

import PrimaryNav from './PrimaryNav';
import Footer from './Footer';
import { Routes } from '../../routes';
import useWindowSize from '../../hooks/useWindowSize';
import SlideOutPanel from './SlideOutPanel';

import MenuIcon from '../../assets/template/menu.svg';
import AdventureBibleLogo from '../../assets/adventure-bible-logo.png';
import AdventureBibleSchoolsLogo from '../../assets/adventure-bible-logo-schools.png';

import './Template.scss';

import Env from '../../utils/env';

const { SHOP_HOME_URL, TEACHER_PORTAL } = Env;
const logoImage = TEACHER_PORTAL ? AdventureBibleSchoolsLogo : AdventureBibleLogo;
const homeUrl = TEACHER_PORTAL ? '#' : SHOP_HOME_URL;
const showPrimaryNav = !TEACHER_PORTAL;

type TemplateVariant = 'game' | 'island' | 'default';
interface Props {
  children: React.ReactNode
}

const Template = ({ children }: Props): React.ReactElement => {
  const location: { pathname: string } = useLocation();
  const windowSize = useWindowSize();
  const [menuOpen, setMenuOpen] = useState(false);

  const variant: TemplateVariant = (
    matchPath(location.pathname, Routes.Islands.Games.View) && 'game'
  ) || (
    matchPath(location.pathname, Routes.Islands.Index) && 'island'
  ) || 'default';

  useEffect(() => {
    if (windowSize.isGreaterThanXLarge) {
      setMenuOpen(false);
    }
  }, [windowSize.isGreaterThanXLarge]);

  const classNames = [
    'screen',
    variant,
    TEACHER_PORTAL ? 'teacher-portal' : undefined,
  ];

  return (
    <div className={classNames.join(' ')}>
      {showPrimaryNav && !windowSize.isGreaterThanXLarge && (
        <SlideOutPanel open={menuOpen} onClose={() => setMenuOpen(false)}>
          <PrimaryNav />
        </SlideOutPanel>
      )}

      <header className="head">
        <a className="link image-link logo" href={homeUrl} title="Adventure Bible Home">
          <img className="image" src={logoImage} alt="Adventure Bible Logo" />
        </a>

        {showPrimaryNav && windowSize.isGreaterThanXLarge && (
          <PrimaryNav />
        )}

        {showPrimaryNav && !windowSize.isGreaterThanXLarge && (
          <button
            onClick={() => setMenuOpen((val) => !val)}
            type="button"
            className="button secondary icon-button "
          >
            <img src={MenuIcon} alt="Open panel" className="icon" />
          </button>
        )}
      </header>

      <main className="main">
        {children}
      </main>

      <Footer />
    </div>
  );
};

export default Template;
